export function isMyContactsFilterTabActive(filterParams) {
    return !!filterParams?.contacts;
}
